/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface ServiceRequest
 */
export interface ServiceRequest {
  /**
   *
   * @type {string}
   * @memberof ServiceRequest
   */
  name?: string
}

/**
 * Check if a given object implements the ServiceRequest interface.
 */
export function instanceOfServiceRequest(value: object): boolean {
  let isInstance = true

  return isInstance
}

export function ServiceRequestFromJSON(json: any): ServiceRequest {
  return ServiceRequestFromJSONTyped(json, false)
}

export function ServiceRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ServiceRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    name: !exists(json, 'name') ? undefined : json['name'],
  }
}

export function ServiceRequestToJSON(value?: ServiceRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    name: value.name,
  }
}
